import { Link, Stack, Typography } from '@mui/material';
import { ExternalUrls, SUPPORT_EMAIL } from '@/constants';

export const HelpFooter = () => {
  return (
    <Stack spacing={1}>
      <Typography fontWeight="semibold">Dúvidas?</Typography>
      <Typography fontWeight="semibold">
        Email:{' '}
        <Link href={`mailto:${SUPPORT_EMAIL}`} fontWeight="regular">
          {SUPPORT_EMAIL}
        </Link>{' '}
        <br />
        ou acesse nosso{' '}
        <Link
          href={ExternalUrls.Support}
          target="_blank"
          rel="noopener"
          fontWeight="regular"
        >
          WhatsApp
        </Link>
      </Typography>
    </Stack>
  );
};
